export enum WarehouseItemPhotoAction {
  Replace = "replace",
  Upsert = "upsert",
  Propose = "propose",
}
